/**
 * Base path prefix for building links.
 *
 * With clean per-domain URLs the market is pinned by the request host, so the
 * public path carries no /{country}/{locale} prefix. The base path is therefore
 * always empty — links are built as `${basePath}/products` → `/products`, and
 * the middleware rewrites them to the internal [country]/[locale] route.
 */
export function extractBasePath(_pathname: string): string {
  return "";
}

/**
 * The public path after the (now-absent) /{country}/{locale} prefix. Since the
 * clean URL has no prefix, the pathname is returned unchanged.
 */
export function getPathWithoutPrefix(pathname: string): string {
  return pathname;
}
